// a library to wrap and simplify api calls

import Constants from './Constants'
import apisauce from 'apisauce'

class Api {
    constructor() {

        this.createNonAuthEndpoint = (baseURL) => apisauce.create({
            // base URL is read from the "constructor"
            baseURL: baseURL + '/',

            // here are some default headers
            headers: {
                'Cache-Control': 'no-cache'
            },
            // 100 second timeout...
            timeout: 10000
        })


        this.createAuthEndpoint = (baseURL) => apisauce.create({
            // base URL is read from the "constructor"
            baseURL: baseURL + '/api/',
            // here are some default headers
            headers: {
                'Cache-Control': 'no-cache'
            },
            // 100 second timeout...
            timeout: 100000
        })

        this.createS3UploadEndpoint = (baseURL = Constants.s3URL) => apisauce.create({
            baseURL: baseURL,

            headers: {
                'Content-Type': 'multipart/form-data'
            },

            timeout: 160000

        })

        this.initialize = (baseURL) => {
            this.apiClientNonAuth = this.createNonAuthEndpoint(baseURL)
            this.apiClientAuth = this.createAuthEndpoint(baseURL)
            this.apis3upload = this.createS3UploadEndpoint()
        }

        // Login And Users
        this.userLogin = (credentials, transform) => this.apiClientNonAuth.post('login', credentials)
        this.getUser = (config) => this.apiClientAuth.get('v2/user', null, { headers: { 'X-SELECT': JSON.stringify(config) } })
        this.putUser = (payload) => this.apiClientAuth.put('v2/user/', payload)

        this.magicLinkLogin = (magicLink) => this.apiClientNonAuth.get(`login/magic-link/${magicLink}`, null)

        // Student List
        this.fetchStudentList = param => this.apiClientAuth.get('v2/student/search', null, { headers: { 'X-SELECT': JSON.stringify(param) } })
        this.fetchCustomStudentList = param => this.apiClientAuth.get('v2/student/custom/search', null, { headers: { 'X-SELECT': JSON.stringify(param) } })

        // Program And Organizations
        this.getProgramByOrganization = (param) => this.apiClientAuth.get('v2/program', null, { headers: { 'X-SELECT': JSON.stringify(param) } })
        this.getProgram = param => this.apiClientAuth.get(`v2/program/${param}`, null)
        this.getOrganization = param => this.apiClientAuth.get('v2/organization/' + param)
        this.editOrganization = (id, payload) => this.apiClientAuth.put('v2/organization/' + id, payload)
        this.getClasses = (orgId) => this.apiClientAuth.get('v2/organization/classes', null, { headers: {'X-SELECT': JSON.stringify({'org_id': orgId})}})

        // Reports
        this.getReport = (reportType, config) => this.apiClientAuth.get(`v2/report/school/${reportType}`, null, { headers: {'X-SELECT': JSON.stringify(config)} })        
        this.getStudentReport = (reportType, config) => this.apiClientAuth.get(`v2/report/student/${reportType}`, null, { headers: {'X-SELECT': JSON.stringify(config)} })
        this.fetchDMFTIndex =  params => this.apiClientAuth.get('v2/student/dentalDmft', null, { headers: {'X-SELECT': JSON.stringify(params)} })

        // Content Node
        this.getContentNode = param => this.apiClientAuth.get('v2/content', null, { headers: { 'X-SELECT': JSON.stringify(param) } })
        this.addContentNode = param => this.apiClientAuth.post('v2/content', param)
        this.editContentNode = param => this.apiClientAuth.put('v2/content', param)

        // Dashboard
        this.getHealthOverviewReport = param => this.apiClientAuth.get('/v2/reports/overview/health', null, { headers: { 'X-SELECT': JSON.stringify(param) } })
        this.getClassOverviewReport = param => this.apiClientAuth.get('/v2/reports/overview/class', null, { headers: { 'X-SELECT': JSON.stringify(param) } })
        this.getGenderOverviewReport = param => this.apiClientAuth.get('/v2/reports/overview/gender', null, { headers: { 'X-SELECT': JSON.stringify(param) } })
        this.getHygieneOverviewReport = param => this.apiClientAuth.get('/v2/reports/overview/hygiene', null, { headers: { 'X-SELECT': JSON.stringify(param) } })
        this.getGrowthOverviewReport = param => this.apiClientAuth.get('/v2/reports/overview/growth', null, { headers: { 'X-SELECT': JSON.stringify(param) } })

        this.fetchLatestGrowthOverview = config => this.apiClientAuth.get('v2/reports/latest/overview/growth', null, { headers: { 'X-SELECT': JSON.stringify(config) } })

        // Content Associations
        this.getContentAssociation = param => this.apiClientAuth.get('v2/content/association', null, { headers: { 'X-SELECT': JSON.stringify(param) } })
        this.addContentAssociation = param => this.apiClientAuth.post('v2/content/association', param)
        this.editContentAssociation = param => this.apiClientAuth.put('v2/content/association', param)

        // Glossary
        this.getGlossary = () => this.apiClientAuth.get('v2/glossary', null)

        // Upload Pictures
        this.getS3Creds = (config) => this.apiClientAuth.get('s3/uploadaccess', null, { headers: { 'X-SELECT': JSON.stringify(config) } })
        this.uploadToS3 = (form, options) => this.apis3upload.post('/', form, options)

        // Upload/Create new user
        this.uploadUser = payload => this.apiClientAuth.post('v2/upload/user', { userRecord: JSON.stringify({ users: payload }) })

        // Locations Meta
        this.getCity = config => this.apiClientAuth.get('v2/city', null, { headers: { 'X-SELECT': JSON.stringify(config) } })
        this.getDistrict = config => this.apiClientAuth.get('v2/district', null, { headers: { 'X-SELECT': JSON.stringify(config) } })
        this.getStates = config => this.apiClientAuth.get('v2/states', null, { headers: { 'X-SELECT': JSON.stringify(config) } })
        this.getCountry = config => this.apiClientAuth.get('v2/country', null, { headers: { 'X-SELECT': JSON.stringify(config) } })

        // Smart Clinic
        this.studentEpisodeSrearch = config => this.apiClientAuth.get('v2/2/nurse/smart/clinic/episode/search', null, { headers: { 'X-SELECT': JSON.stringify(config) } })
        this.clinicStudentSearch = config => this.apiClientAuth.get('v2/2/nurse/smart/clinic/student/search', null, { headers: { 'X-SELECT': JSON.stringify(config) } })
        this.clinicEpisodeStats = config => this.apiClientAuth.get('v2/2/nurse/smart/clinic/episode/stats', null, { headers: { 'X-SELECT': JSON.stringify(config) } })
        
        this.postEpisode = (payload) => this.apiClientAuth.post('v2/user/episode', payload)
        
        // Alerts
        this.fetchAlerts = (config) => this.apiClientAuth.get('v2/alert/user/queue', null, { headers: { 'X-SELECT': JSON.stringify(config) } })
        this.updateAlerts = (config) => this.apiClientAuth.put('v2/alert/user/queue', config)

        // Messages
        this.sendMessage =  (payload) => this.apiClientAuth.post('v2/message', payload)

        this.fetchMessages = config => this.apiClientAuth.get('v2/messages', null, { headers: { 'X-SELECT': JSON.stringify(config) } })
        this.fetchMessagesFrom = config => this.apiClientAuth.get('v2/messages/from', null, { headers: { 'X-SELECT': JSON.stringify(config) } })
        this.fetchMessageReceivers = config => this.apiClientAuth.get('v2/message/receivers', null, { headers: { 'X-SELECT': JSON.stringify(config) } })

        this.fetchMessageUnreadCount = config => this.apiClientAuth.get('v2/message/unread/count', null, { headers: { 'X-SELECT': JSON.stringify(config) } })

        // Misc Meta
        this.fetchNurseMeta = config => this.apiClientAuth.get('v2/nurse/metadata', null, { headers: { 'X-SELECT': JSON.stringify(config) } })
        this.getVaccinationV2 = (config) => this.apiClientAuth.get('v2_2/vaccination/', null,  { headers: { 'X-SELECT': JSON.stringify(config) } })
        
        this.setToken = (token) => {
            this.apiClientAuth.setHeader('Authorization', 'Bearer ' + token.jwt)
        }

    }

}

// let's return back our create method as the default.
export default new Api()



// WEBPACK FOOTER //
// ./src/Phi/PhiApi.js